module.exports = __webpack_public_path__ + "static/media/AP Cartoon.fa87fe9c.png";